import ModalSignUp from '../../../components/photosBox/Modals/ModalSignup';
import { openSidemenu, selectSidemenuItem } from '../../../actions/sidemenuAction';
import { connect } from 'react-redux';

const mapDispatchToProps = {
  openSidemenu,
  selectSidemenuItem
}

export default connect(undefined, mapDispatchToProps)(ModalSignUp)